import actionTypes from "actions/actionTypes"
import { reportError } from "utils/ErrorReporting"
import { getCheckout } from "carrot-api/avaClient"
import { HttpErrors } from "utils/HttpErrors"

export const fetchAvaCheckout = () => async (dispatch) => {
  dispatch({
    type: actionTypes.FETCH_AVA_CHECKOUT_REQUEST
  })

  let response
  try {
    response = await getCheckout()
  } catch (error) {
    if (error.name === HttpErrors.UNAUTHORIZED) {
      dispatch({
        type: actionTypes.SESSION_EXPIRED
      })
      return
    }
    error.message = "Error getting Ava Checkout: " + error.message
    reportError(error)
    return null
  }

  if (!response) {
    dispatch({
      type: actionTypes.FETCH_AVA_CHECKOUT_FAILURE
    })
    return
  }

  dispatch({
    type: actionTypes.FETCH_AVA_CHECKOUT_SUCCESS,
    response
  })
}
